/**
 * WooCommerce Product Bundles – Bundle-Sells handler.
 *
 * Bundle-sells are cross-sell add-ons shown on non-bundle product pages.
 * They use .bundle_data on the form but the form does NOT have .bundle_form class.
 * After the main product is added, selected bundle-sell items are added individually.
 */
import { storeApiFetch } from '../core/shared/api.js';

export default {
	matches(form) {
		return form.querySelector('.bundle_data') && !form.classList.contains('bundle_form');
	},

	buildApiData() {
		return null;
	},

	async afterAddToCart(form, formData, cartData, { refreshCartFromServer, initializeRecommendations }) {
		const bundleDataEl = form.querySelector('.bundle_data');
		const bundleFormData = JSON.parse(bundleDataEl.getAttribute('data-bundle_form_data') || '{}');
		const bsProductIds = bundleFormData.product_ids || {};
		let bundleSellsAdded = false;

		// Collect bundle-sell items: quantities and optional selection state
		const bsItems = {};
		for (const [key, value] of formData.entries()) {
			let m;
			if ((m = key.match(/^bundle_quantity_(\d+)$/))) {
				const id = m[1];
				if (!bsItems[id]) bsItems[id] = {};
				bsItems[id].quantity = parseInt(value) || 0;
			} else if ((m = key.match(/^bundle_selected_optional_(\d+)$/))) {
				const id = m[1];
				if (!bsItems[id]) bsItems[id] = {};
				bsItems[id].selected = true;
			}
		}

		for (const [bundledItemId, item] of Object.entries(bsItems)) {
			if (item.selected !== true || !item.quantity || item.quantity <= 0) continue;

			const bsProductId = bsProductIds[bundledItemId];
			if (!bsProductId) continue;

			await storeApiFetch('cart/add-item', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ id: parseInt(bsProductId), quantity: item.quantity })
			});
			bundleSellsAdded = true;
		}

		if (bundleSellsAdded) {
			await refreshCartFromServer();
			initializeRecommendations();
		}
	}
};
